(function () {
  const initCarousel = () => {
    document.querySelectorAll('.product-carousel-section').forEach(function (section) {
      if (section.classList.contains('carousel-inited')) return;
      section.classList.add('carousel-inited');

      const slider = section.querySelector('.product-carousel__slider');
      if (!slider) return;

      const sectionId = slider.dataset.sectionId;
      const speed = +(slider.dataset.speed || 0.8) * 1000;
      const delay = +(slider.dataset.delay || 3) * 1000;
      const autoplay = slider.dataset.autoplay === 'true';
      const stopAutoplay = slider.dataset.stopAutoplay === 'true';
      const showArrows = slider.dataset.showArrows === 'true';
      const perRow = +(slider.dataset.perRow || 3);
      const mobilePerView = +(slider.dataset.mobilePerView || 1);

      const refEl = section.querySelector('.product-carousel__ref');
      const getOffset = () => (refEl ? Math.max(0, refEl.getBoundingClientRect().left) : 20);

      const autoplayParam = autoplay
        ? {
            autoplay: {
              delay: delay,
              pauseOnMouseEnter: stopAutoplay,
              disableOnInteraction: false,
            },
          }
        : { autoplay: false };

      const navParam = showArrows
        ? {
            navigation: {
              nextEl: `#${sectionId} .swiper-button-next`,
              prevEl: `#${sectionId} .swiper-button-prev`,
            },
          }
        : {};

      const offset = getOffset();

      const swiperEl = section.querySelector('.product-carousel__swiper');
      if (!swiperEl) return;

      const bodyEl = section.querySelector('.product-carousel__body');
      const updateSlideOpacity = (swiper) => {
        const containerRect = (bodyEl || swiperEl).getBoundingClientRect();
        swiper.slides.forEach((slide) => {
          const slideRect = slide.getBoundingClientRect();
          const fullyVisible =
            slideRect.left >= containerRect.left - 1 &&
            slideRect.right <= containerRect.right + 1;
          slide.classList.toggle('is-full-visible', fullyVisible);
        });
      };

      const swiper = new Swiper(swiperEl, {
        speed: speed,
        keyboard: true,
        watchSlidesProgress: true,
        // slidesPerView: mobilePerView === 2 ? 2.15 : 1.16,
        slidesPerView: 'auto',
        spaceBetween: 12,
        slidesOffsetBefore: offset,
        slidesOffsetAfter: offset,
        ...autoplayParam,
        ...navParam,
        breakpoints: {
          576: {
            // slidesPerView: 2.15,
            spaceBetween: 16,
          },
          750: {
            // slidesPerView: 2.35,
            spaceBetween: 16,
          },
          990: {
            // slidesPerView: perRow === 1 ? 1.2 : perRow === 2 ? 2.2 : 3.265,
            spaceBetween: 16,
          },
          1200: {
            // slidesPerView: perRow === 1 ? 1.2 : perRow === 2 ? 2.2 : perRow === 4 ? 3.4 : 3.265,
            spaceBetween: 20,
          },
          1500: {
            // slidesPerView: perRow === 1 ? 1.2 : perRow === 2 ? 2.2 : perRow === 4 ? 4.2 : 3.265,
            spaceBetween: 20,
          },
        },
        on: {
          progress: function () { updateSlideOpacity(this); },
          slideChange: function () { updateSlideOpacity(this); },
          transitionEnd: function () { updateSlideOpacity(this); },
          resize: function () {
            const newOffset = getOffset();
            this.params.slidesOffsetBefore = newOffset;
            this.params.slidesOffsetAfter = newOffset;
            const bpKeys = Object.keys(this.params.breakpoints);
            bpKeys.forEach((bp) => {
              if (this.params.breakpoints[bp].slidesOffsetBefore !== undefined) {
                this.params.breakpoints[bp].slidesOffsetBefore = newOffset;
                this.params.breakpoints[bp].slidesOffsetAfter = newOffset;
              }
            });
            this.update();
            updateSlideOpacity(this);
          },
        },
      });
      requestAnimationFrame(() => updateSlideOpacity(swiper));
    });
  };

  const initVideoHover = () => {
    if (window.__pc2VideoInit) return;
    window.__pc2VideoInit = true;
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('.product-card-2');
      if (!card || card._videoActive) return;
      const video = card.querySelector('.product-card-2__video');
      if (!video) return;
      card._videoActive = true;
      video.play().catch(() => {});
    });
    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('.product-card-2');
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      const video = card.querySelector('.product-card-2__video');
      if (!video) return;
      card._videoActive = false;
      video.pause();
      video.currentTime = 0;
    });
  };

  const initMobileAutoplay = () => {
    if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
    const playAll = () => {
      document.querySelectorAll('.product-card-2__video').forEach((v) => v.play().catch(() => {}));
    };
    playAll();
    document.addEventListener('shopify:section:load', playAll);
  };

  document.addEventListener('DOMContentLoaded', function () {
    initCarousel();
    initVideoHover();
    initMobileAutoplay();
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.product-carousel-section').forEach(function (section) {
        section.classList.remove('carousel-inited');
      });
      initCarousel();
    });
  });
})();
